import BaseFormModel from './base-form-model';
import store from '@/store';
import modelsStore from '@/lib/services/models-store';

import defineMethodsChildren from '@/lib/helpers/define-methods-children';
import ValidationManager from '@/lib/models/validation-manager';

import {
  CREATE_VALUE_FIELD,
} from '@/lib/constants/mutations';

import {
  FIELD_TYPE,
  VALIDATION_TYPE,
} from '@/lib/constants/model-types';

import defineProperty from '@/lib/helpers/define-property';

class Field extends BaseFormModel {
  constructor(component, {
    name,
    uiProps,
    defaultValue,
    optional,
    readOnly,
    presence,
    blocker,
    customNotEmptyErrorMessage,
  }) {
    super(component, uiProps);

    defineProperty(this, 'name');
    this.name = name;

    defineProperty(this, 'optional');
    this.optional = optional;

    defineProperty(this, 'readOnly');
    this.readOnly = readOnly;

    defineProperty(this, 'presence');
    this.presence = presence;

    defineProperty(this, 'blocker');
    this.blocker = blocker;

    defineProperty(this, 'customNotEmptyErrorMessage');
    this.customNotEmptyErrorMessage = customNotEmptyErrorMessage;

    let pDefaultValue = defaultValue;
    if (typeof defaultValue === 'undefined') {
      pDefaultValue = null;
    }

    store.commit(CREATE_VALUE_FIELD, {
      name,
      defaultValue: pDefaultValue,
    });

    defineMethodsChildren(this, {
      selfName: Field.$modelName,
      nameSingular: 'validation',
      namePlural: 'validations',
      type: VALIDATION_TYPE,
    });
    this.__validationManager = new ValidationManager(this);
  }

  get step() {
    return this.fieldset.step;
  }

  get form() {
    return this.step.form;
  }

  get value() {
    return store.state.formData.values[this.name];
  }

  get isUnprocessed() {
    return this.__validationManager.isUnprocessed;
  }

  get isOptional() {
    return this.optional;
  }

  get isValid() {
    return this.__validationManager.isValid;
  }

  get isInvalid() {
    return this.__validationManager.isInvalid;
  }

  get validationState() {
    return this.__validationManager.validationState;
  }

  static get $modelType() {
    return FIELD_TYPE;
  }

  static get $modelName() {
    return 'field';
  }

  static get $parentName() {
    return 'fieldset';
  }

  get isBlocked() {
    return this.blocker;
  }

  get isEditable() {
    return !this.readOnly
      && this.fieldset.isEditable
      && !this.isBlocked
      && this.transactionalBlockers.length === 0;
  }

  get isLoading() {
    return this.loaders.length > 0;
  }

  forceValidations() {
    this.__validationManager.forceValidations();
  }

  /**
   * This method should be call when a considered instant change of values are being made.
   * On instant changes no async request are being handle
   * @param {T} newValue
   */
  onInstantChange(newValue) {
    if (this.isEditable) {
      this.__validationManager.runInstantValidations(newValue);
    } else {
      console.log('Value is not editable');
    }
  }

  /**
   *
   * @param {*} newValue
   */
  async onChange(newValue, options = {}) {
    if (this.isEditable) {
      this.__validationManager.runChangeValidations(newValue, options);
    } else {
      console.log('Value is not editable');
    }
  }

  get errorMessages() {
    const invalidValidations = this.validations.filter(v => v.isInvalid);

    const errorMessages = invalidValidations.map(v => v.errorMessage);

    return errorMessages;
  }
}

modelsStore.registerClass(Field);

export default Field;
